import React, { Component, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { CSSTransition } from 'react-transition-group';

import Reply from './reply';
import CommentEditForm from './forms/commentEditForm';
import ReplyForm from './forms/replyForm';
import CommentOwnerMenu from './menus/commentOwnerMenu';
import CommentReportMenu from './menus/commentReportMenu';

import { ListItem, Divider, ListItemAvatar, Avatar, ListItemText, Typography, IconButton, ListItemSecondaryAction, Chip, Tooltip } from '@mui/material'
import AvatarGroup from '@mui/material/AvatarGroup';
import Skeleton from '@mui/material/Skeleton';

import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ReplyIcon from '@mui/icons-material/Reply';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useSelector, useDispatch } from 'react-redux';
import produce from 'immer';
import { useImmer } from 'use-immer';

import moment from 'moment';

const PREFIX = 'Comment';

const classes = {
    root: `${PREFIX}-root`,
    avatarSection: `${PREFIX}-avatarSection`,
    textSection: `${PREFIX}-textSection`,
    text: `${PREFIX}-text`,
    menuSection: `${PREFIX}-menuSection`,
    icons: `${PREFIX}-icons`,
    replySection: `${PREFIX}-replySection`,
    showReplies: `${PREFIX}-showReplies`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
      //width: '97%',
      display: 'flex',
      justifyContent: 'flex-start',
    },

    [`& .${classes.avatarSection}`]: {
    //display: 'flex',
    //flexDirection: 'column',
    padding: '10px',
    //cursor: 'pointer',
	},

    [`& .${classes.textSection}`]: {
		width: '77%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    padding: '5px'
	},

    [`& .${classes.text}`]: {
    width: '100%',
    //width: '425px',
    //display: 'flex',
    justifyContent: 'flex-start',
	},

    [`& .${classes.menuSection}`]: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5px'
	},

    [`& .${classes.icons}`]: { 
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
	},

    [`& .${classes.replySection}`]: {
		paddingLeft: '50px',
	},

    [`& .${classes.showReplies}`]: {
		paddingLeft: '15px',
	}
}));

const Comment = (props) => {
	
	const { updateContent, comment } = props;	
	
	const user = useSelector(state => state.user);
	const newsfeed = useSelector(state => state.newsfeed);
	const dispatch = useDispatch();


  const [isCommentDeleted, setIsCommentDeleted] = useState(false);
  const [isEditFormClicked, setIsEditFormClicked] = useState(false);
  const [isReplyFormClicked, setIsReplyFormClicked] = useState(false);
  const [isMouseEntered, setIsMouseEntered] = useState(false);
  const [isChildEntered, setIsChildEntered] = useState(false);
	
  const [isReplyOpen, setIsReplyOpen] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const [mouseOver, setMouseOver] = useState(false);

  const [pageNum, setPageNum] = useState(0);

	const { root } = useSelector(state => state.api);

  var isCommentOwner = false;
  if(user){
    for(var i = 0; i < comment.writer.length; i++) {
      if(comment.writer[i]._id == user._id){
        isCommentOwner = true;
        /*
        var owner = comment.writer[i];
        comment.writer.splice(i, 1);
        comment.writer.splice(0, 0, owner);
        break;
        */
      }
    }
  }

  let chipColor;
  if(isCommentOwner&&comment.text&&comment.text.charAt(0) === '#'){
    const commonTags = (comment.writer[0]?.tags ?? []).filter(tag => tag.name.toLowerCase() === comment.text.toLowerCase())
    if(commonTags.length > 0) chipColor = commonTags[0].color;
  }

	const handleInitReplies = () => {
		setIsReplyOpen(true)
		if(comment.replies && comment.replies.length > 0) return; //just open the already loaded replies
		setLoading(true)
		fetch(`${root}/api/reply/init?comment_id=${comment._id}`, { method: 'get', credentials: 'include' })
			.then(res => res.json())
			.then(json => {
				setLoading(false);
				console.log('json is', json);
				if(json.length < 8){setHasMore(false)}
				updateContent(draft =>{
					draft.comments.find(element => element._id === comment._id).replies = json;
				})
				setPageNum(pageNum+1)
			})
			.catch(err => console.log(err))
	}

	const handleMouseMove = () => {
    if(mouseOver) return;
    setMouseOver(true);
	}

	const handleMoreReplies = () => {
		setLoading(true);
		fetch(`${root}/api/reply/more/${comment._id}/${pageNum}/${props.loadedTime}`, { method: 'get', credentials: 'include' })
			.then(res => res.json())
			.then(json => {
				setLoading(false);
				console.log('json is', json);
				if(json.length < 8){setHasMore(false)}
				updateContent(draft =>{
				  const a =	draft.comments.find(function(element){return element._id === comment._id});
          a.replies = a.replies.concat(json);
				})
        setPageNum(pageNum+1);
			})
			.catch(err => console.log(err))
	}

	const handleCommentLike = () => {
    if(!user) return dispatch({ type: 'OPEN_SIGN_$' });
    //(isCommentOwner) return;
		if(comment.userReaction.length === 0){
			fetch(`${root}/api/reaction/comment/${comment._id}/1/0`, { method: 'put', credentials: 'include' })
				.then(res => console.log('reaction update success'))
				.catch(err => console.log(err))
			updateContent(draft => {
				const a = draft.comments.find(function(element){return element._id === comment._id})
				a.likeCount++; 
				a.userReaction = [{type: 1}];
			});
			return;
		} else {
		switch (comment.userReaction[0].type){ 
			case -1:
				fetch(`${root}/api/reaction/comment/${comment._id}/1/-1`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
					const a = draft.comments.find(function(element){return element._id === comment._id})
					a.likeCount++; 
					a.dislikeCount--;
					a.userReaction[0].type = 1;
				});
				break;
			case 0:
				fetch(`${root}/api/reaction/comment/${comment._id}/1/0`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
					const a = draft.comments.find(function(element){return element._id === comment._id})
					a.likeCount++; 
					a.userReaction[0].type = 1;
				});
				break;
			case 1:
				fetch(`${root}/api/reaction/comment/${comment._id}/1/1`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
					const a = draft.comments.find(function(element){return element._id === comment._id})
					a.likeCount--; 
					a.userReaction[0].type = 0;
				});
				break;
		}
	}}

	const handleCommentDislike = () => {
    if(!user) return dispatch({ type: 'OPEN_SIGN_$' });
    //if(isCommentOwner) return;
		if(comment.userReaction.length === 0){
			fetch(`${root}/api/reaction/comment/${comment._id}/-1/0`, { method: 'put', credentials: 'include' })
				.then(res => console.log('reaction update success'))
				.catch(err => console.log(err))
			updateContent(draft => {
				const a = draft.comments.find(function(element){return element._id === comment._id})
				a.dislikeCount++;
				a.userReaction = [{ type: -1 }];
			});
			return;
		} else {
		switch (comment.userReaction[0].type){ 
			case -1:
				fetch(`${root}/api/reaction/comment/${comment._id}/-1/-1`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
					const a = draft.comments.find(function(element){return element._id === comment._id})
					a.dislikeCount--;
					a.userReaction[0].type = 0;
				});
				break;
			case 0:
				fetch(`${root}/api/reaction/comment/${comment._id}/-1/0`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
					const a = draft.comments.find(function(element){return element._id === comment._id})
					a.dislikeCount++;
					a.userReaction[0].type = -1;
				});
				break;
			case 1:
				fetch(`${root}/api/reaction/comment/${comment._id}/-1/1`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
					const a = draft.comments.find(function(element){return element._id === comment._id})
					a.likeCount--; 
					a.dislikeCount++;
					a.userReaction[0].type = -1;
				});
				break;
		}
	}}
  
                  //<button type="button" class="btn btn-secondary" data-dismiss="modal" onClick={handleSignOut}>Sign out</button>

  const handleReplyFormClick = () => {
    if(!user) return dispatch({ type: 'OPEN_SIGN_$' });
    setIsReplyFormClicked(prev => !prev)
  }

	return (
        <Root>
                {
                    !isEditFormClicked 
                    ?
                            <div className={classes.root} onMouseOver={()=>setMouseOver(true)} onMouseOut={()=>setMouseOver(false)} onMouseMove={handleMouseMove}>
                                <div>
                <IconButton
                    className={classes.avatarSection}
                    onClick={()=>dispatch({type:'OPEN_DRAWER', path: `/api/activities?person_id=${comment.writer[0]._id}`})}
                    size="large">
                  <AvatarGroup max={1}>
                    {
                      comment.writer.length === 2
                      ?
                        <div>
                          <Avatar alt="" src={comment.writer[0].profileImageUrl}/>
                          <Avatar alt="" src=''>
                            +1
                          </Avatar>
                        </div>
                      :
                        comment.writer.map(person => <Avatar alt="" src={person.profileImageUrl}/>)
                    }
                  </AvatarGroup>
                </IconButton>
            </div>
            <div className={classes.textSection}>
              <div style={{display:'flex', flexDirection: 'row'}}>
                <Typography variant="body" gutterBottom>{comment.writer[0].username || comment.writer[0].email + "  " + comment.createdAt.substr(0, 10)}</Typography>
                <Typography variant="body"   style={{paddingLeft: '15px'}}  gutterBottom>{moment(comment.createdAt).fromNow(true)}</Typography>
              </div>
              <div align='left'>
              {(comment.hashtags ?? []).map((hashtag, i) => (
                <Chip
                  key={hashtag._id ?? `${hashtag.name}-${i}`}
                  size="small"
                  variant="outlined"
                  label={`#${String(hashtag.name ?? '').replace(/^#/, '')}`}
                  sx={{
                    m: '5px',
                    bgcolor: 'transparent',
                    borderColor: 'divider',
                  }}
                />
              ))}
              {(comment.persontags ?? []).map(persontag => <Chip label={'@'+persontag.username}/>)}
              </div>
              <Typography variant="body" align="left"  style={{ wordWrap: "break-word" }}>
                {comment.text}
              </Typography>
              <div className={classes.icons} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                <IconButton
                    aria-label="like"
                    onClick={handleCommentLike}
                    size="small">
                  {
                    comment.userReaction && comment.userReaction.length > 0 && comment.userReaction[0].type === 1 
                    ? 
                      <FavoriteIcon fontSize='small' style={{color: 'red'}}/>
                    :
                      <FavoriteBorderIcon fontSize='small'/>
                  }
                </IconButton>
                <Typography variant="body2" component="span" color="text.secondary">
                  {comment.likeCount <= 0 ? 0 : comment.likeCount}
                </Typography>
                <IconButton aria-label="reply" onClick={handleReplyFormClick} size="small">
                  <ReplyIcon fontSize="small" />
                </IconButton>
                <Typography variant="body2" component="span" color="text.secondary">
                  {comment.replyCount ?? 0}
                </Typography>
              </div>

            </div>
                                <div className={classes.menuSection} style={{opacity: mouseOver? 1 : 0}}>
                                    { 
                                        isCommentOwner 
                                        ?
                                            <CommentOwnerMenu contentId={comment.contentId} commentId={comment._id} updateContent={updateContent} setIsEditFormClicked={setIsEditFormClicked} setMouseOver={setMouseOver}/> 
                                        : 
                                            <CommentReportMenu commentId={comment._id} updateContent={updateContent} handleOpen={props.handleOpen} setMouseOver={setMouseOver}/> 
                                    }
                                </div>
          </div>
                    :
                        <CommentEditForm comment={comment} updateContent={updateContent} setIsEditFormClicked={setIsEditFormClicked}/>
                }
                <div className={classes.replySection}>
                    { 
                        isReplyFormClicked 
                        ? 
          <ReplyForm className={classes.replyForm} comment={comment} updateContent={updateContent} setIsReplyFormClicked={setIsReplyFormClicked} setIsReplyOpen={setIsReplyOpen}/> 
                        : 
                            null 
                    }
                    {
                        comment.replies && comment.replies.length > 0 && isReplyOpen 
                    ?
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            {
                                comment.replies.map(reply =>(	
                                    <Reply reply ={reply} updateContent={updateContent} setIsChildEntered={setIsChildEntered} contentId={comment.contentId} commentId={comment._id} setIsReplyOpen={setIsReplyOpen} handleOpen={props.handleOpen} />
                                ))
                            }
                            { 
                                /*
                                loading
                                ?
                                  <Skeleton/>
                                :
                                    comment.replies.length >= 8 && hasMore === true 
                                    ? 
                                        <div>
                                            <Button onClick={handleMoreReplies} size="small">More</Button> 
                                        </div>
                                    : 
                                    null  
                                */
                            }
                        </div>
                    :
                            null
                    }
                    {
                        comment.replyCount > 0 && isReplyOpen === false
                        ?
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                              <Tooltip title="Show replies">
                                <IconButton size="small" aria-label="Show replies" onClick={handleInitReplies}>
                                  <ExpandMoreIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Typography variant="body2" component="span" color="text.secondary">
                                {comment.replyCount}
                              </Typography>
                            </div>
                        :
          loading
        ?
          <Skeleton/>
        :
                            null
                    }
      {
                        !loading && comment.replyCount > 0 && isReplyOpen === true
                        ?
                            <Tooltip title="Hide replies">
                              <IconButton size="small" aria-label="Hide replies" onClick={() => setIsReplyOpen(false)}>
                                <ExpandLessIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                        :
          null
      }
    </div>
        </Root>
    );
}

export default Comment;

